import { render, staticRenderFns } from "./announcementsView.vue?vue&type=template&id=bbb37da8"
import script from "./announcementsView.vue?vue&type=script&lang=js"
export * from "./announcementsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports